import {Settings} from "./Settings.js";
import {DefaultSearchFieldsHorseTrailer} from "./DefaultSearchFieldsHorseTrailer";
import {DefaultSearchFieldsCargoTrailer} from "./DefaultSearchFieldsCargoTrailer";
import {DefaultSearchFieldsTruck} from "./DefaultSearchFieldsTruck";
import {DefaultSearchFieldsPart} from "./DefaultSearchFieldsPart";
import states from "./States";

class SearchFields {

    constructor() {
        this.cache = [];

        this.years = [];
        for (let index=(new Date()).getFullYear()+1; index >= 1980; index--) {
            this.years.push({
                value: index.toString(),
                label: index.toString()
            })
        }

    }

    getFields(inventoryType, inventoryCategory) {

        if (inventoryType === Settings.inventoryTypes.NONE) {
            return Promise.resolve([]);
        }

        let cacheKey = "";
        if (inventoryType !== Settings.inventoryTypes.INVENTORY) {
            cacheKey = inventoryType;
        } else {
            cacheKey = "inventory-" + inventoryCategory
        }

        if (typeof this.cache[cacheKey] !== "undefined") {
            // Return a copy of the defaults
            return Promise.resolve(JSON.parse(JSON.stringify(this.cache[cacheKey])));
        }

        if (inventoryType === Settings.inventoryTypes.TRAILER) {
            // Start with the defaults
            this.cache[cacheKey] = DefaultSearchFieldsHorseTrailer;

            // Hide any fields that have been specified in the configuration
            if (Array.isArray(Settings.hideTrailerSearchFieldsByLabel)) {
                Settings.hideTrailerSearchFieldsByLabel.forEach(element => {
                    let filter = this.cache[cacheKey].fields.find(x => x.label === element);
                    if (filter) {
                        filter.hideField = true;
                    }
                });
            }


            // Fetch additional information from the server
            let me = this;
            let trailerPromise1 = fetch(Settings.trailersUrl + "?action=distinctmanu")
                .then(function (response) {
                    return response.text();
                })
                .then(function (responseText) {
                        let parser = new window.DOMParser();
                        let elementsXML = parser.parseFromString(responseText, "text/xml");
                        let elementsNodes = elementsXML.getElementsByTagName("c_manu");
                        let elementsArray = [];
                        for (let i = 0; i < elementsNodes.length; i++) {
                            if (elementsNodes[i].childNodes[0]) {
                                let val = elementsNodes[i].childNodes[0].nodeValue.trim();
                                if (val.length > 0) {
                                    elementsArray.push(elementsNodes[i].childNodes[0].nodeValue);
                                }
                            }
                        }

                        elementsArray.sort();

                        let objs = elementsArray.map((element) => {
                            return {
                                label: element,
                                value: element
                            }
                        });

                        me.cache[cacheKey].fields.find(x => x.filterId === "7").searchValues = objs;
                    }
                );

            let trailerPromise2 = fetch(Settings.trailersUrl + "?action=distincthorses")
                .then(function (response) {
                    return response.text();
                })
                .then(function (responseText) {
                        let parser = new window.DOMParser();
                        let elementsXML = parser.parseFromString(responseText, "text/xml");
                        let elementsNodes = elementsXML.getElementsByTagName("c_horses");
                        let elementsArray = [];
                        for (let i = 0; i < elementsNodes.length; i++) {
                            if (elementsNodes[i].childNodes[0]) {
                                let val = elementsNodes[i].childNodes[0].nodeValue.trim();
                                if (val.length > 0) {
                                    elementsArray.push(elementsNodes[i].childNodes[0].nodeValue);
                                }
                            }
                        }

                        // Prune
                        let existingValues = me.cache[cacheKey].fields.find(x => x.filterId === "9");
                        existingValues.searchValues =
                            existingValues.searchValues.filter((element) => {
                                return elementsArray.indexOf(element.value) >= 0;
                            });
                    }
                );

            let trailerAllPromise = Promise.all([trailerPromise1, trailerPromise2])
                .then((values) => {
                    // Make a copy of the object
                    return JSON.parse(JSON.stringify(me.cache[cacheKey]));
                });
            return trailerAllPromise;
        }

        if (inventoryType === Settings.inventoryTypes.CARGO) {

            // Start with the defaults
            this.cache[cacheKey] = DefaultSearchFieldsCargoTrailer;
            let me = this;

            // Hide any fields that have been specified in the configuration
            if (Array.isArray(Settings.hideCargoSearchFieldsByLabel)) {
                Settings.hideCargoSearchFieldsByLabel.forEach(element => {
                    let filter = this.cache[cacheKey].fields.find(x => x.label === element);
                    if (filter) {
                        filter.hideField = true;
                    }
                });
            }

            // Fetch additional information from the server
            let cargoPromise1 = fetch(Settings.cargoUrl + "?action=distinctmanu")
                .then(function (response) {
                    return response.text();
                })
                .then(function (responseText) {
                        let parser = new window.DOMParser();
                        let elementsXML = parser.parseFromString(responseText, "text/xml");
                        let elementsNodes = elementsXML.getElementsByTagName("ct_manu");
                        let elementsArray = [];
                        for (let i = 0; i < elementsNodes.length; i++) {
                            if (elementsNodes[i].childNodes[0]) {
                                let val = elementsNodes[i].childNodes[0].nodeValue.trim();
                                if (val.length > 0) {
                                    elementsArray.push(elementsNodes[i].childNodes[0].nodeValue);
                                }
                            }
                        }

                        elementsArray.sort();

                        let objs = elementsArray.map((element) => {
                            return {
                                label: element,
                                value: element
                            }
                        });

                        me.cache[cacheKey].fields.find(x => x.filterId === "7").searchValues = objs;
                    }
                );

            let cargoPromise2 = fetch(Settings.cargoUrl + "?action=distincttype")
                .then(function (response) {
                    return response.text();
                })
                .then(function (responseText) {
                        let parser = new window.DOMParser();
                        let elementsXML = parser.parseFromString(responseText, "text/xml");
                        let elementsNodes = elementsXML.getElementsByTagName("ct_type");
                        let elementsArray = [];
                        for (let i = 0; i < elementsNodes.length; i++) {
                            if (elementsNodes[i].childNodes[0]) {
                                let val = elementsNodes[i].childNodes[0].nodeValue.trim();
                                if (val.length > 0) {
                                    elementsArray.push(elementsNodes[i].childNodes[0].nodeValue);
                                }
                            }
                        }

                        // Prune
                        let existingValues = me.cache[cacheKey].fields.find(x => x.filterId === "4");
                        existingValues.searchValues =
                            existingValues.searchValues.filter((element) => {
                                return elementsArray.indexOf(element.value) >= 0;
                            });
                    }
                );

            let cargoPromise3 = fetch(Settings.cargoUrl + "?action=distinctyear")
                .then(function (response) {
                    return response.text();
                })
                .then(function (responseText) {
                        let parser = new window.DOMParser();
                        let elementsXML = parser.parseFromString(responseText, "text/xml");
                        let elementsNodes = elementsXML.getElementsByTagName("ct_year");
                        let elementsArray = [];
                        for (let i = 0; i < elementsNodes.length; i++) {
                            if (elementsNodes[i].childNodes[0]) {
                                let val = elementsNodes[i].childNodes[0].nodeValue.trim();
                                if (val.length > 0) {
                                    elementsArray.push(elementsNodes[i].childNodes[0].nodeValue);
                                }
                            }
                        }
                        elementsArray.sort().reverse();

                        let objs = elementsArray.map((element) => {
                            return {
                                label: element,
                                value: element
                            }
                        });

                        me.cache[cacheKey].fields.find(x => x.filterId === "5").searchValues = objs;
                    }
                );

            let cargoAllPromise = Promise.all([cargoPromise1, cargoPromise2, cargoPromise3])
                .then((values) => {
                    return me.cache[cacheKey];
                });

            return cargoAllPromise;
        }

        if (inventoryType === Settings.inventoryTypes.TRUCK) {
            // Start with the defaults
            this.cache[cacheKey] = DefaultSearchFieldsTruck;
            let me = this;


            // Hide any fields that have been specified in the configuration
            if (Array.isArray(Settings.hideTruckSearchFieldsByLabel)) {
                Settings.hideTruckSearchFieldsByLabel.forEach(element => {
                    let filter = this.cache[cacheKey].fields.find(x => x.label === element);
                    if (filter) {
                        filter.hideField = true;
                    }
                });
            }

            // Fetch additional information from the server
            let truckPromise1 = fetch(Settings.trucksUrl + "?action=distinctengine")
                .then(function (response) {
                    return response.text();
                })
                .then(function (responseText) {
                        let parser = new window.DOMParser();
                        let elementsXML = parser.parseFromString(responseText, "text/xml");
                        let elementsNodes = elementsXML.getElementsByTagName("t_engine");
                        let elementsArray = [];
                        for (let i = 0; i < elementsNodes.length; i++) {
                            if (elementsNodes[i].childNodes[0]) {
                                let val = elementsNodes[i].childNodes[0].nodeValue.trim();
                                if (val.length > 0) {
                                    elementsArray.push(elementsNodes[i].childNodes[0].nodeValue);
                                }
                            }
                        }

                        elementsArray.sort();

                        let objs = elementsArray.map((element) => {
                            return {
                                label: element,
                                value: element
                            }
                        });

                        me.cache[cacheKey].fields.find(x => x.filterId === "6").searchValues = objs;
                    }
                );

            let truckPromise2 = fetch(Settings.trucksUrl + "?action=distinctmake")
                .then(function (response) {
                    return response.text();
                })
                .then(function (responseText) {
                        let parser = new window.DOMParser();
                        let elementsXML = parser.parseFromString(responseText, "text/xml");
                        let elementsNodes = elementsXML.getElementsByTagName("t_make");
                        let elementsArray = [];
                        for (let i = 0; i < elementsNodes.length; i++) {
                            if (elementsNodes[i].childNodes[0]) {
                                let val = elementsNodes[i].childNodes[0].nodeValue.trim();
                                if (val.length > 0) {
                                    elementsArray.push(elementsNodes[i].childNodes[0].nodeValue);
                                }
                            }
                        }

                        elementsArray.sort();

                        let objs = elementsArray.map((element) => {
                            return {
                                label: element,
                                value: element
                            }
                        });

                        me.cache[cacheKey].fields.find(x => x.filterId === "3").searchValues = objs;
                    }
                );

            let truckAllProimise = Promise.all([truckPromise1, truckPromise2])
                .then((values) => {
                    return me.cache[cacheKey];
                });

            return truckAllProimise;
        }

        if (inventoryType === Settings.inventoryTypes.PART) {
            // Start with the defaults
            this.cache[cacheKey] = DefaultSearchFieldsPart;
            let me = this;

            // Hide any fields that have been specified in the configuration
            if (Array.isArray(Settings.hidePartSearchFieldsByLabel)) {
                Settings.hidePartSearchFieldsByLabel.forEach(element => {
                    let filter = this.cache[cacheKey].fields.find(x => x.label === element);
                    if (filter) {
                        filter.hideField = true;
                    }
                });
            }

            // Fetch additional information from the server
            let partPromise1 = fetch(Settings.partsUrl + "?action=distinctmake")
                .then(function (response) {
                    return response.text();
                })
                .then(function (responseText) {
                        let parser = new window.DOMParser();
                        let elementsXML = parser.parseFromString(responseText, "text/xml");
                        let elementsNodes = elementsXML.getElementsByTagName("t_make");
                        let elementsArray = [];
                        for (let i = 0; i < elementsNodes.length; i++) {
                            if (elementsNodes[i].childNodes[0]) {
                                let val = elementsNodes[i].childNodes[0].nodeValue.trim();
                                if (val.length > 0) {
                                    elementsArray.push(elementsNodes[i].childNodes[0].nodeValue);
                                }
                            }
                        }

                        elementsArray.sort();

                        let objs = elementsArray.map((element) => {
                            return {
                                label: element,
                                value: element
                            }
                        });
                        objs.unshift({
                            label: "Any",
                            value: ""
                        });
                        me.cache[cacheKey].fields.find(x => x.filterId === "3").searchValues = objs;
                    }
                );

            let partPromise2 = fetch(Settings.partsUrl + "?action=distinctmodel")
                .then(function (response) {
                    return response.text();
                })
                .then(function (responseText) {
                        let parser = new window.DOMParser();
                        let elementsXML = parser.parseFromString(responseText, "text/xml");
                        let elementsNodes = elementsXML.getElementsByTagName("t_model");
                        let elementsArray = [];
                        for (let i = 0; i < elementsNodes.length; i++) {
                            if (elementsNodes[i].childNodes[0]) {
                                let val = elementsNodes[i].childNodes[0].nodeValue.trim();
                                if (val.length > 0) {
                                    elementsArray.push(elementsNodes[i].childNodes[0].nodeValue);
                                }
                            }
                        }

                        elementsArray.sort();

                        let objs = elementsArray.map((element) => {
                            return {
                                label: element,
                                value: element
                            }
                        });
                        objs.unshift({
                            label: "Any",
                            value: ""
                        });
                        me.cache[cacheKey].fields.find(x => x.filterId === "4").searchValues = objs;
                    }
                );

            let partPromise3 = fetch(Settings.partsUrl + "?action=distinctyear")
                .then(function (response) {
                    return response.text();
                })
                .then(function (responseText) {
                        let parser = new window.DOMParser();
                        let elementsXML = parser.parseFromString(responseText, "text/xml");
                        let elementsNodes = elementsXML.getElementsByTagName("t_year");
                        let elementsArray = [];
                        for (let i = 0; i < elementsNodes.length; i++) {
                            if (elementsNodes[i].childNodes[0]) {
                                let val = elementsNodes[i].childNodes[0].nodeValue.trim();
                                if (val.length > 0) {
                                    elementsArray.push(elementsNodes[i].childNodes[0].nodeValue);
                                }
                            }
                        }

                        elementsArray.sort().reverse();

                        let objs = elementsArray.map((element) => {
                            return {
                                label: element,
                                value: element
                            }
                        });

                        me.cache[cacheKey].fields.find(x => x.filterId === "2").searchValues = objs;
                    }
                );

            let partPromise4 = fetch(Settings.partsUrl + "?action=distinctcategory")
                .then(function (response) {
                    return response.text();
                })
                .then(function (responseText) {
                        let parser = new window.DOMParser();
                        let elementsXML = parser.parseFromString(responseText, "text/xml");
                        let elementsNodes = elementsXML.getElementsByTagName("CategoryName");
                        let elementsArray = [];
                        for (let i = 0; i < elementsNodes.length; i++) {
                            if (elementsNodes[i].childNodes[0]) {
                                let val = elementsNodes[i].childNodes[0].nodeValue.trim();
                                if (val.length > 0) {
                                    elementsArray.push(elementsNodes[i].childNodes[0].nodeValue);
                                }
                            }
                        }

                        elementsArray.sort();

                        let objs = elementsArray.map((element) => {
                            return {
                                label: element,
                                value: element
                            }
                        });
                        objs.unshift({
                            label: "Any",
                            value: ""
                        });
                        me.cache[cacheKey].fields.find(x => x.filterId === "34").searchValues = objs;
                    }
                );
            let partAllPromise = Promise.all([partPromise1, partPromise2, partPromise3, partPromise4])
                .then((values) => {
                    return me.cache[cacheKey];
                });

            return partAllPromise;
        }

        if (inventoryType === Settings.inventoryTypes.INVENTORY) {
            let me = this;

            // Fetch additional information from the server
            let inventoryPromise1 = fetch(Settings.baseApi + "Listings/Category/" + inventoryCategory + "/Options/",
                {
                    method: 'GET',
                    withCredentials: true,
                    credentials: 'omit',
                    headers: {
                        Authorization: Settings.authHeader
                    }
                })
                .then(function (response) {
                    return response.json();
                })
                .then(function (responseJson) {
                        let objs = {fields: []};
                        objs.categoryName = responseJson.categoryName;
                        for (let categoryIndex = 0; categoryIndex < responseJson.results.length; categoryIndex++) {

                            let category = responseJson.results[categoryIndex];

                            for (let questionsIndex = 0; questionsIndex < category.options.questions.length; questionsIndex++) {
                                let question = category.options.questions[questionsIndex];
                                if (question.searchable) {
                                    if (question.optionType === Settings.inventoryFieldType.TEXTBOX ||
                                        question.optionType === Settings.inventoryFieldType.TEXTAREA) {
                                        objs.fields.push({
                                            hideField: false,
                                            label: question.name,
                                            fieldType: "textbox",
                                            searchValue: "",
                                            selectedValue: "",
                                            selectedValues: [],
                                            filterId: question.optionId.toString(),
                                            maxLength: question.maxLength,
                                            inventoryQueryType: Settings.inventoryQueryType.QUESTION,
                                        });
                                    } else if (question.optionType === Settings.inventoryFieldType.RADIO ||
                                        question.optionType === Settings.inventoryFieldType.RADIOWITHTEXT ||
                                        question.optionType === Settings.inventoryFieldType.SELECT ||
                                        question.optionType === Settings.inventoryFieldType.SELECTWITHTEXT ||
                                        question.optionType === Settings.inventoryFieldType.AUTOCOMPLETE) {
                                        question.defaultValueCollection.defaultValues.unshift({label: "Any", value: ""});
                                        objs.fields.push({
                                            hideField: false,
                                            label: question.name,
                                            fieldType: "select",
                                            searchValues: question.defaultValueCollection.defaultValues,
                                            selectedValue: "",
                                            selectedValues: [],
                                            filterId: question.optionId.toString(),
                                            inventoryQueryType: Settings.inventoryQueryType.QUESTION,
                                        });
                                    } else if (question.optionType === Settings.inventoryFieldType.MULTIPLE ||
                                        question.optionType === Settings.inventoryFieldType.MULTIPLEWITHTEXT) {

                                        objs.fields.push({
                                            hideField: false,
                                            label: question.name,
                                            fieldType: "multiselect",
                                            searchValues: question.defaultValueCollection.defaultValues,
                                            selectedValue: "",
                                            selectedValues: [],
                                            filterId: question.optionId.toString(),
                                            inventoryQueryType: Settings.inventoryQueryType.QUESTION,
                                        });
                                    } else if (question.optionType === Settings.inventoryFieldType.YESNO) {

                                        objs.fields.push({
                                            hideField: false,
                                            label: question.name,
                                            fieldType: "checkbox",
                                            searchValue: "1",
                                            selectedValue: "",
                                            selectedValues: [],
                                            filterId: question.optionId.toString(),
                                            inventoryQueryType: Settings.inventoryQueryType.QUESTION,
                                        });
                                    } else if (question.optionType === Settings.inventoryFieldType.YEAR) {

                                        objs.fields.push({
                                            hideField: false,
                                            label: question.name,
                                            fieldType: "multiselect",
                                            searchValues: me.years,
                                            selectedValue: "",
                                            selectedValues: [],
                                            filterId: question.optionId.toString(),
                                            inventoryQueryType: Settings.inventoryQueryType.QUESTION,
                                        });
                                    } else if (question.optionType === Settings.inventoryFieldType.STATE) {

                                        objs.fields.push({
                                            hideField: false,
                                            label: question.name,
                                            fieldType: "multiselect",
                                            searchValues: states.slice(),
                                            selectedValue: "",
                                            selectedValues: [],
                                            filterId: question.optionId.toString(),
                                            inventoryQueryType: Settings.inventoryQueryType.QUESTION,
                                        });
                                    }
                                }
                            }
                        }
                        objs.fields.unshift({
                            hideField: false,
                            label: "State",
                            fieldType: "multiselect",
                            searchValues: states.slice(),
                            selectedValue: "",
                            selectedValues: [],
                            filterId: "state",
                            inventoryQueryType: Settings.inventoryQueryType.CONTACTSTATE,
                        });
                        objs.fields.unshift({
                            hideField: false,
                            label: "Distance from zipcode",
                            fieldType: "textbox",
                            searchValue: "",
                            selectedValue: "",
                            selectedValues: [],
                            filterId: "zip",
                            inventoryQueryType: Settings.inventoryQueryType.CONTACTZIP,
                        });
                        objs.fields.unshift({
                            hideField: false,
                            label: "Title",
                            fieldType: "textbox",
                            searchValue: "",
                            selectedValue: "",
                            selectedValues: [],
                            filterId: "title",
                            inventoryQueryType: Settings.inventoryQueryType.TITLE,
                        });


                        me.cache[cacheKey] = objs;
                    }
                )

            let inventoryAllPromise = Promise.all([inventoryPromise1])
                .then((values) => {
                    return me.cache[cacheKey];
                });

            return inventoryAllPromise;
        }
    }
}

let DefaultSearchFields = new SearchFields();
export {DefaultSearchFields}